/**
 * @generated SignedSource<<c4e5517ff13355db001293f383f8a042>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateMethodOfUseInput = {
  description: string;
};
export type CreateProcedureInput = {
  description: string;
};
export type CreateEaseOfUseRatingInput = {
  description: string;
};
export type CreateAgeGroupInput = {
  beginAge: number;
  endAge: number;
  groupNumber: number;
  groupPercentage: number;
};
export type CreateJobMutation$variables = {
  ageGroups?: ReadonlyArray<CreateAgeGroupInput | null> | null;
  childrenIds?: ReadonlyArray<string | null> | null;
  customerId: string;
  customerTest?: string | null;
  description?: string | null;
  disclaimer?: string | null;
  easeOfUseRatings?: ReadonlyArray<CreateEaseOfUseRatingInput | null> | null;
  endDate?: any | null;
  jobCategoryId: string;
  key: string;
  maxParticipantsPerProctor?: number | null;
  maxParticipantsPerSite?: number | null;
  methodsOfUse?: ReadonlyArray<CreateMethodOfUseInput | null> | null;
  notes?: string | null;
  numberOfParticipants?: number | null;
  objectives?: string | null;
  otherInfo?: string | null;
  parentId?: string | null;
  participantType?: string | null;
  preparedById: string;
  procedureNotes?: string | null;
  procedures?: ReadonlyArray<CreateProcedureInput | null> | null;
  regionIds: ReadonlyArray<string>;
  reportHistory?: string | null;
  reportTree?: number | null;
  requiredParticipants?: number | null;
  requiredTorque?: number | null;
  resultsDiscussion?: string | null;
  samplePicture?: string | null;
  sampleType?: string | null;
  status: string;
  submitter?: string | null;
  testDescription?: string | null;
  testObjectId?: string | null;
  testType?: string | null;
};
export type CreateJobMutation$data = {
  readonly createJob: {
    readonly id: string;
  } | null;
};
export type CreateJobMutation = {
  response: CreateJobMutation$data;
  variables: CreateJobMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ageGroups"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "childrenIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customerId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customerTest"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disclaimer"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "easeOfUseRatings"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jobCategoryId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxParticipantsPerProctor"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxParticipantsPerSite"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "methodsOfUse"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notes"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numberOfParticipants"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectives"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherInfo"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "participantType"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "preparedById"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "procedureNotes"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "procedures"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regionIds"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportHistory"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportTree"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requiredParticipants"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requiredTorque"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resultsDiscussion"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "samplePicture"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sampleType"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "submitter"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "testDescription"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "testObjectId"
},
v34 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "testType"
},
v35 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "ageGroups",
            "variableName": "ageGroups"
          },
          {
            "kind": "Variable",
            "name": "childrenIds",
            "variableName": "childrenIds"
          },
          {
            "kind": "Variable",
            "name": "customerId",
            "variableName": "customerId"
          },
          {
            "kind": "Variable",
            "name": "customerTest",
            "variableName": "customerTest"
          },
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          },
          {
            "kind": "Variable",
            "name": "disclaimer",
            "variableName": "disclaimer"
          },
          {
            "kind": "Variable",
            "name": "easeOfUseRatings",
            "variableName": "easeOfUseRatings"
          },
          {
            "kind": "Variable",
            "name": "endDate",
            "variableName": "endDate"
          },
          {
            "kind": "Variable",
            "name": "jobCategoryId",
            "variableName": "jobCategoryId"
          },
          {
            "kind": "Variable",
            "name": "key",
            "variableName": "key"
          },
          {
            "kind": "Variable",
            "name": "maxParticipantsPerProctor",
            "variableName": "maxParticipantsPerProctor"
          },
          {
            "kind": "Variable",
            "name": "maxParticipantsPerSite",
            "variableName": "maxParticipantsPerSite"
          },
          {
            "kind": "Variable",
            "name": "methodsOfUse",
            "variableName": "methodsOfUse"
          },
          {
            "kind": "Variable",
            "name": "notes",
            "variableName": "notes"
          },
          {
            "kind": "Variable",
            "name": "numberOfParticipants",
            "variableName": "numberOfParticipants"
          },
          {
            "kind": "Variable",
            "name": "objectives",
            "variableName": "objectives"
          },
          {
            "kind": "Variable",
            "name": "otherInfo",
            "variableName": "otherInfo"
          },
          {
            "kind": "Variable",
            "name": "parentId",
            "variableName": "parentId"
          },
          {
            "kind": "Variable",
            "name": "participantType",
            "variableName": "participantType"
          },
          {
            "kind": "Variable",
            "name": "preparedById",
            "variableName": "preparedById"
          },
          {
            "kind": "Variable",
            "name": "procedureNotes",
            "variableName": "procedureNotes"
          },
          {
            "kind": "Variable",
            "name": "procedures",
            "variableName": "procedures"
          },
          {
            "kind": "Variable",
            "name": "regionIds",
            "variableName": "regionIds"
          },
          {
            "kind": "Variable",
            "name": "reportHistory",
            "variableName": "reportHistory"
          },
          {
            "kind": "Variable",
            "name": "reportTree",
            "variableName": "reportTree"
          },
          {
            "kind": "Variable",
            "name": "requiredParticipants",
            "variableName": "requiredParticipants"
          },
          {
            "kind": "Variable",
            "name": "requiredTorque",
            "variableName": "requiredTorque"
          },
          {
            "kind": "Variable",
            "name": "resultsDiscussion",
            "variableName": "resultsDiscussion"
          },
          {
            "kind": "Variable",
            "name": "samplePicture",
            "variableName": "samplePicture"
          },
          {
            "kind": "Variable",
            "name": "sampleType",
            "variableName": "sampleType"
          },
          {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
          },
          {
            "kind": "Variable",
            "name": "submitter",
            "variableName": "submitter"
          },
          {
            "kind": "Variable",
            "name": "testDescription",
            "variableName": "testDescription"
          },
          {
            "kind": "Variable",
            "name": "testObjectId",
            "variableName": "testObjectId"
          },
          {
            "kind": "Variable",
            "name": "testType",
            "variableName": "testType"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Job",
    "kind": "LinkedField",
    "name": "createJob",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateJobMutation",
    "selections": (v35/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v13/*: any*/),
      (v8/*: any*/),
      (v19/*: any*/),
      (v22/*: any*/),
      (v30/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v31/*: any*/),
      (v34/*: any*/),
      (v18/*: any*/),
      (v25/*: any*/),
      (v14/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v3/*: any*/),
      (v24/*: any*/),
      (v33/*: any*/),
      (v26/*: any*/),
      (v5/*: any*/),
      (v16/*: any*/),
      (v23/*: any*/),
      (v32/*: any*/),
      (v15/*: any*/),
      (v20/*: any*/),
      (v27/*: any*/),
      (v7/*: any*/),
      (v12/*: any*/),
      (v21/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v17/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateJobMutation",
    "selections": (v35/*: any*/)
  },
  "params": {
    "cacheID": "2a8233a332485367902afeda6a3b1d48",
    "id": null,
    "metadata": {},
    "name": "CreateJobMutation",
    "operationKind": "mutation",
    "text": "mutation CreateJobMutation(\n  $key: String!\n  $customerId: ID!\n  $description: String\n  $notes: String\n  $jobCategoryId: ID!\n  $preparedById: ID!\n  $regionIds: [ID!]!\n  $status: String!\n  $samplePicture: String\n  $sampleType: String\n  $submitter: String\n  $testType: String\n  $participantType: String\n  $requiredParticipants: Int\n  $numberOfParticipants: Int\n  $maxParticipantsPerSite: Int\n  $maxParticipantsPerProctor: Int\n  $customerTest: String\n  $reportTree: Int\n  $testObjectId: ID\n  $requiredTorque: Int\n  $disclaimer: String\n  $otherInfo: String\n  $reportHistory: String\n  $testDescription: String\n  $objectives: String\n  $procedureNotes: String\n  $resultsDiscussion: String\n  $endDate: DateTime\n  $methodsOfUse: [CreateMethodOfUseInput]\n  $procedures: [CreateProcedureInput]\n  $easeOfUseRatings: [CreateEaseOfUseRatingInput]\n  $ageGroups: [CreateAgeGroupInput]\n  $parentId: ID\n  $childrenIds: [ID]\n) {\n  createJob(input: {key: $key, customerId: $customerId, description: $description, notes: $notes, jobCategoryId: $jobCategoryId, preparedById: $preparedById, regionIds: $regionIds, status: $status, samplePicture: $samplePicture, sampleType: $sampleType, submitter: $submitter, testType: $testType, participantType: $participantType, requiredParticipants: $requiredParticipants, numberOfParticipants: $numberOfParticipants, maxParticipantsPerSite: $maxParticipantsPerSite, maxParticipantsPerProctor: $maxParticipantsPerProctor, customerTest: $customerTest, reportTree: $reportTree, testObjectId: $testObjectId, requiredTorque: $requiredTorque, disclaimer: $disclaimer, otherInfo: $otherInfo, reportHistory: $reportHistory, testDescription: $testDescription, objectives: $objectives, procedureNotes: $procedureNotes, resultsDiscussion: $resultsDiscussion, methodsOfUse: $methodsOfUse, procedures: $procedures, easeOfUseRatings: $easeOfUseRatings, ageGroups: $ageGroups, parentId: $parentId, childrenIds: $childrenIds, endDate: $endDate}) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1784ecf77a6f71c7cc3d3b2b0d5fe43b";

export default node;
